import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-code-grid',
  templateUrl: './code-grid.component.html',
  styleUrls: ['./code-grid.component.scss']
})
export class CodeGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
